import PubSub from "pubsub.js"

const contextArgument = ["MockupGenerator"]
const instance = PubSub.newInstance({
    context: contextArgument,
    async: false,
})

export default instance
